import type React from 'react';

import { Outlet } from 'react-router-dom';

import { PermissionDeniedErrorPage } from '@platform/client/components/errors/permission-denied-error-page';

import { useHasCapabilities } from '@apis/capability/use-has-capabilities';
import { useOrganizationParam } from '@packages/hooks/use-organization-param';

export type CapabilitiesGuardProps = React.PropsWithChildren<{
  capabilities: Parameters<typeof useHasCapabilities>[1];
}>;

/** @experimental For application using `@platform` only. */
export const CapabilitiesGuard = ({
  capabilities,
  children,
}: CapabilitiesGuardProps) => {
  const organizationId = useOrganizationParam();
  const hasCapabilities = useHasCapabilities(organizationId, capabilities);

  return hasCapabilities ? (
    children || <Outlet />
  ) : (
    <PermissionDeniedErrorPage />
  );
};
